import { ReactComponent as Error } from '@/assets/svgs/icon-error-message-exclamation.svg'
import Button from '@/components/Button'
import DexLeftComponent from '@/components/DexLeftComponent'
import IconEye from '@/components/IconEye'
import usePage from '@/hooks/use-page'
import { useNavigate, useQuery } from '@/lib/router-dom'
import API_PASSWORD from '@/services/api/resetPassword.js'
import validatePassword from '@/utils/validate-password'
import axios from 'axios'
import classname from 'classnames'
import { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'

const Page = () => {

	/*=================================================
		General
	/================================================*/

	usePage({ title: 'Reset Password' })

	const { goTo } = useNavigate()

	const { register, handleSubmit, formState: { errors, isValid }, getValues, setValue, watch, trigger } = useForm({
		mode: 'onChange'
	})

	const [error, setError] = useState(null)

	const query = useQuery()

	// const [errorMessage, setErrorMessage] = useState()
	// const [message, setMessage] = useState(false)
	const [loading, setLoading] = useState(false)

	const [passwordMask, setPasswordMask] = useState(true);
	const [verifyPasswordMask, setVerifyPasswordMask] = useState(true);
	const [passwordFieldState, setPasswordFieldState] = useState(false)
	const [confirmPasswordFieldState, setConfirmPasswordFieldState] = useState(false)

	const passwordMinLength = 12;

	// Watch password fields and trigger validation on the other field
	const watchPassword = watch('password');
	const watchVerifyPassword = watch('verifyPassword');

	useEffect(() => {
		if (watchPassword && watchVerifyPassword) {
			trigger('verifyPassword');
		}
	}, [watchPassword]);

	useEffect(() => {
		if (watchPassword && watchVerifyPassword) {
			trigger('password');
		}
	}, [watchVerifyPassword]);

	/*=================================================
		API
	/================================================*/

	function resetValue() {
		setValue('password', "");
		setValue('verifyPassword', "");
		setPasswordFieldState(false)
		setConfirmPasswordFieldState(false)
	}

	async function submitHandler(data) {
		if (loading) {
			return
		}

		setLoading(true)

		let token = query.get("token")

		axios.defaults.headers.post['Authorization'] = `Bearer ${token}`
		const [error, response] = await API_PASSWORD.create({ password: data.password })

		setLoading(false)
		if (error) {
			switch (error?.response?.data) {
				case "Invalid token.":
					setError("Reset password link expired, please try to reset the password again from the <a href='/login'><b>login page</b></a>.")
					break;
				default:
					if (String(error.message.toLowerCase()).includes("status code")) {
						setError("An error occured! Please contact administrator.");
					} else {
						setError(error.message)
					}
			}
			resetValue()
			return
		}
		delete axios.defaults.headers.post['Authorization']

		goTo('/reset-password/success')
	}

	function goToLogIn() {
		goTo(`/login`)
	}

	const passwordInputClass = classname({
		'input--error': errors.password
	})

	return (
		<div className='layout-login'>
			<DexLeftComponent />
			<div className="layout-login__right">
				<div className="login-box">
					<div className="resetPassword-box__title">Reset Password</div>
					<div className="resetPassword-box__desc">Enter a new password</div>
					<div className="resetPassword-box__form">
						<form onSubmit={handleSubmit(submitHandler)}>
							<div className="resetPassword-box__form__cols ">
								{error && (
									<div className="t--required resetPassword-box__form__error">
										<div><Error /></div>
										<div dangerouslySetInnerHTML={{ __html: error }}></div>
									</div>
								)}
								<div className="resetPassword-box__form__col">
									<input name='password' className={passwordInputClass} type={passwordMask ? 'password' : 'text'}
										placeholder="New Password"
										ref={register({
											required: "Required",
											validate: {
												checkLength: v => v.length >= passwordMinLength || "Error",
												verifyPasswordRequirement: v => validatePassword(v) || "Error",
												matchConfirmPassword: v => !getValues().verifyPassword || v === getValues().verifyPassword || "Passwords do not match"
											}
										})}
										data-testid="secret-input"
										autoComplete="off"
										onChange={(e) => { setPasswordFieldState(true) }}
									/>
									<span data-testid="reveal-btn" className="link icon-eye" onClick={() => setPasswordMask(!passwordMask)}>
										<IconEye bool={passwordMask} />
									</span>
								</div>
								<div className="resetPassword-box__form__col">
									<input name='verifyPassword' className={passwordInputClass} type={verifyPasswordMask ? 'password' : 'text'}
										placeholder="Confirm New Password"
										ref={register({
											required: "Required",
											validate: {
												verifyPassword2: v => v === getValues().password || "Passwords do not match"
											}
										})}
										data-testid="secret-input1"
										autoComplete="off"
										onChange={(e) => { setConfirmPasswordFieldState(true) }}
									/>
									<span data-testid="reveal-btn1" className="link icon-eye" onClick={() => setVerifyPasswordMask(!verifyPasswordMask)}>
										<IconEye bool={verifyPasswordMask} />
									</span>
								</div>
								{(
									<div className="resetPassword-box__caption">
										<strong>Password must contain:</strong><br />
										<div className='resetPassword-box__caption-list'>
											<ul>
												<li>Minimum {passwordMinLength} characters</li>
												<li>At least 1 uppercase letter, lowercase letter, symbol, and number</li>
											</ul>
										</div>
									</div>
								)}
								<div className="resetPassword-box__form__action">
									<div>
										<Button text="Confirm" type="submit" id="reset-password-button-trigger" maxWidth="168" full round
											disabled={!isValid || !passwordFieldState || !confirmPasswordFieldState}
											loading={loading} />
									</div>
								</div>
							</div>
							<div className='login-box__desc'>
								<span className="link" onClick={() => goToLogIn()}>Log in instead</span>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	)
}
export default Page
